//3rd Party Components
import React, { Fragment } from 'react';
import AUpageAlert from '@gov.au/page-alerts';
import { useState, useEffect } from 'react';
import { useSelector } from "react-redux";

//Actions
import { getUrlSelector, getSystemSelector } from '../../PortalStore/Selectors/EnvDataSelectors';
import { getPortalUrl } from '../Portal/Utilities';

const TimeoutWarning = () => {

    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let urlHome = useSelector(state => getUrlSelector(state, "Portal - Home URL"));

    let timeoutWarning = useSelector(state => getSystemSelector(state, "Portal - Timeout Warning"));
    let timeoutNow = useSelector(state => getSystemSelector(state, "Portal - Timeout Now"));

    let intervalHandle = 0;

    const [minutes, setMinutes] = useState(5);
    const [seconds, setSeconds] = useState(0);
    const [showwarning, setShowwarning] = useState(false);

    //change to seconds when all pages ported
    let timerwarninglength = (parseInt(timeoutNow, 10) - parseInt(timeoutWarning, 10)) / 1000;
    let timertimeoutlength = parseInt(timeoutNow, 10) / 1000;
    let secondsRemaining = timertimeoutlength;

    const events = [
        //"load",
        //"mousemove",
        //"mousedown",
        "click",
        //"scroll",
        "keypress"
    ];

    useEffect(() => {
        intervalHandle = setInterval(tick, 1000);

        for (var i in events) {
            window.addEventListener(events[i], resetPortalTimeout);
        }
    }, [])

    const tick = () => {
        secondsRemaining--;

        if (secondsRemaining === timerwarninglength) {
            setShowwarning(true);
        }

        if (secondsRemaining < timerwarninglength) {
            setShowwarning(true);
            var min = Math.floor(secondsRemaining / 60);
            var sec = secondsRemaining - (min * 60);
            setMinutes(min);
            setSeconds(sec);
        }

        if (secondsRemaining === 0) {
            clearInterval(intervalHandle);
            var loc = getPortalUrl("/timedout?timedout=1", standalone, urlHome);
            window.location.assign(loc); //push
        }
    }

    const resetPortalTimeout = () => {
        secondsRemaining = timertimeoutlength;
        setShowwarning(false);
    }

    const warning = () => {
        
        return (
            <AUpageAlert as="warning" style={showwarning ? {} : { display: 'none' }}>
                <div id="sessionExpiryNotification" aria-live="polite">
                    <br />
                    <h3>Inactivity Alert</h3>
                    <p>For security reasons you will be signed out within <span className="sessionExpiryTime">5</span> minute(s) due to inactivity.</p>
                    <h1>Time Remaining: {minutes}:{seconds < 10 ? `0${seconds}` : seconds}</h1>
                    <br />
                    <button className="au-btn" id="btnSessionExpiryExtend">Extend</button>
                    <br />
                </div>
            </AUpageAlert>
        )

    }    
    
    return (
        <Fragment>
            {warning()}
        </Fragment>
    )    
}

TimeoutWarning.propTypes = {
};

export default TimeoutWarning;



